import { get } from './';
export const getThemes = () => get(`/api/v1/themes`);
